module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Epigraph-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "frontmatter epigraph",
      "id": "Epigraph1"
    }
  }, [_c('div', {
    staticClass: "epigraph-rw",
    attrs: {
      "id": "epigraph1"
    }
  }, [_c('p', {
    staticClass: "ep1-rw",
    attrs: {
      "id": "firstpara4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "firstpara5"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "firstpara6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "firstpara7"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "firstpara8"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p39"
    }
  }, [_c('i', [_vm._v("“Find what you love, and let it kill you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "source-rw",
    attrs: {
      "id": "source11"
    }
  }, [_c('i', [_vm._v("—Charles Bukowski")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22300d8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s004-Epigraph-01.vue
// module id = 72
// module chunks = 0